import React from "react";
import "./ProcessBarSection.css";

const ProcessBarSection = () => {
  return (
    <div className="popup_loading_overlay popupBoxSectionIsOpen">
      <div className="zino_renderer_loader"></div>
    </div>
  );
};

const ProcessBarBox = () => {
  return (
    <div className="popup_loading_overlay_box">
      <div className="zino_renderer_loader"></div>
    </div>
  );
};

export default ProcessBarSection;

export { ProcessBarBox };
